import { useLocation, useNavigate } from 'react-router-dom'
import { useTheme } from './ThemeProvider'
import MindPolishLogo from './MindPolishLogo'

const Footer = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { theme } = useTheme()
  const isDark = theme === 'dark'

  // Only show footer on info/legal pages
  const showFooter = ['/about', '/contact', '/privacy', '/disclaimer', '/terms'].includes(location.pathname)

  if (!showFooter) return null

  const footerLinks = [
    { path: '/home', label: 'Home', icon: '🏠' },
    { path: '/about', label: 'About', icon: '📄' },
    { path: '/contact', label: 'Contact', icon: '📬' },
    { path: '/privacy', label: 'Privacy', icon: '🔐' },
    { path: '/terms', label: 'Terms', icon: '📜' }
  ]

  return (
    <footer className="bg-white/60 dark:bg-sage-800/60 border-t border-sage-100/30 dark:border-sage-700/30 p-4 sm:p-6">
      <div className="max-w-2xl mx-auto">
        <div className="flex justify-center mb-4">
          <MindPolishLogo size="sm" withText={false} />
        </div>
        
        <nav className="grid grid-cols-5 gap-2">
          {footerLinks.map((link) => (
            <button
              key={link.path}
              onClick={() => navigate(link.path)}
              className={`flex flex-col items-center space-y-1 p-2 rounded-xl transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-sage-100 dark:focus:ring-sage-600 ${
                location.pathname === link.path
                  ? 'text-sage-600 dark:text-sage-300'
                  : 'text-sage-400 dark:text-sage-500 hover:text-sage-600 dark:hover:text-sage-300'
              }`}
            >
              <span className="text-sm sm:text-base">{link.icon}</span>
              <span className="text-xs font-light">{link.label}</span>
            </button>
          ))}
        </nav>
        
        <div className="text-center mt-3 pt-3 border-t border-sage-100/30 dark:border-sage-700/30">
          <p className="text-sage-400 dark:text-sage-500 text-xs font-light">
            Mind Polish • Built with care for your wellbeing
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer